export function formatPoints(value: string | null | undefined): string {
  if (!value) return '0';
  return Math.round(parseFloat(value)).toLocaleString();
}

export function formatCurrency(value: string | null | undefined): string {
  if (!value) return '£0';
  return `£${Math.round(parseFloat(value)).toLocaleString()}`;
}

export function formatCurrencyShort(value: string | null | undefined): string {
  if (!value) return '£0';
  const num = Math.round(parseFloat(value));
  if (num >= 1000 && num % 1000 === 0) return `£${num / 1000}K`;
  if (num >= 1000) return `£${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  return `£${num.toLocaleString()}`;
}

export function progressPercent(earned: string, required: string): number {
  const earnedNum = parseFloat(earned);
  const requiredNum = parseFloat(required);
  if (!requiredNum) return 0;
  return Math.min(100, Math.round((earnedNum / requiredNum) * 100));
}

export function downPaymentPercent(investment: string, target: string): number {
  const investmentNum = parseFloat(investment);
  const targetNum = parseFloat(target);
  if (!targetNum) return 0;
  return Math.min(100, Math.round((investmentNum / targetNum) * 100));
}

export function familiesHelped(pointsEarned: string | null | undefined): number {
  if (!pointsEarned) return 0;
  return Math.floor(parseFloat(pointsEarned) / 300);
}

export function formatDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function parseContactMonth(contactMonth: string): Date {
  const [year = 0, month = 1] = contactMonth.split('-').map(Number);
  return new Date(year, month - 1, 1);
}

export function formatContactMonth(contactMonth: string): string {
  return parseContactMonth(contactMonth).toLocaleDateString('en-GB', {
    month: 'short',
    year: 'numeric',
  });
}
